import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

function FixedElementsPortal({ children, isMobileLayout, isMarathonFoto }) {
  const [container] = useState(() => document.createElement('div'));

  useEffect(() => {
    const portalRoot = document.getElementById('portal-root-for-fixed-el');
    
    portalRoot.classList.toggle('sportograf-version', !isMarathonFoto);
    portalRoot.classList.toggle('mobile-version', isMobileLayout);
    portalRoot.classList.toggle('desktop-version', !isMobileLayout);

    portalRoot.appendChild(container);
    container.classList.add('container-960');

    if (portalRoot.childElementCount > 1) {
      // hiding previous child so that only one is shown
      portalRoot.firstChild.classList.add('hidden-mobile-portal-el');
    }

    return () => {
      if (portalRoot.contains(container)) {
        portalRoot.removeChild(container);
        // shawing again previous child if second one was removed
        if (
          portalRoot.childElementCount === 1 &&
          portalRoot.firstChild.classList.contains('hidden-mobile-portal-el')
        ) {
          portalRoot.firstChild.classList.remove('hidden-mobile-portal-el');
        }
      }
    };
  }, [container, isMobileLayout]);

  return ReactDOM.createPortal(children, container);
}

FixedElementsPortal.defaultProps = {
  isMobileLayout: true,
};

FixedElementsPortal.propTypes = {
  isMobileLayout: PropTypes.bool,
  children: PropTypes.node,
};

export default FixedElementsPortal;
